import styled from 'styled-components';
import { toRem, baseVariables } from '../../styles';

export const StyledCheckboxControlsList = styled.div`
  .show-more-btn {
    background: none;
    padding: ${toRem(0)};
    .show-more-icon {
      vertical-align: top;
    }
    .icon-dropdown-down:before,
    .icon-dropdown-up:before {
      font-size: ${toRem(22)};
    }
  }
  .checkbox-control-title-wrapper {
    margin-top: ${toRem(20)} !important;
  }
  .checkbox-controls-list__checkbox {
    min-width: fit-content;
  }
  .checkbox-item {
    width: 50%;
  }
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
  }
  .tooltip-checkbox-item {
    display: inline-flex;
    width: 50%;
    .tooltip-information {
      .tooltip-icon {
        padding: 0;
        font-size: ${toRem(16)};
        margin-left: ${toRem(4)};
        &:after {
          position: relative;
          padding: 0;
          top: ${toRem(1)};
        }
        &:hover {
          background-color: ${baseVariables.color['base20']};
        }
        &:focus {
          border: none;
        }
        .tooltip-dialog {
          position: absolute;
          transform: translateX(-46%) translateY(-74%);
          z-index: 1;
        }
      }
    }
  }
`;
